<template xmlns="http://www.w3.org/1999/html">
  <details :id="'webinar-' + index"
           class="my-4">
      <summary class="text-white font-bold p-2 bg-green-default">
        {{ title }}
      </summary>
      <div class="prose bard m-4" v-html="result.description"></div>
      <ul class="flex flex-row gap-2 flex-wrap m-4">
        <li v-if="result.collection"
            class=" py-1 px-3 border text-xs ">{{collectionName}}</li>
        <li v-for="(category, index) in result.categories"
            :id="'category-' + index"
            class=" py-1 px-3 border text-xs">{{category.title}}</li>
        <li v-for="(crop, index) in result.crops"
            :id="'crop-' + index"
            class=" py-1 px-3 border text-xs">{{crop.title}}</li>
        <li v-for="(tag, index) in result.tags"
            :id="'tag-' + index"
            class=" py-1 px-3 border text-xs">{{tag.title}}</li>
      </ul>
      <div class="flex flex-col md:flex-row m-4 gap-8">
        <a v-if="this.result.link && !this.result.tags.some((tag) => {return tag.title.toLowerCase() === 'archived';})" :href="this.result.link" class="py-3 px-6 text-white inline-block bg-grass-default" target="_blank" rel="noreferrer"><i class="fas fa-users-class"></i> Watch</a>
        <a v-if="fileUrl" :href="fileUrl" class="py-3 px-6 text-white inline-block bg-grass-default" target="_blank" rel="noreferrer"><i class="fas fa-download"></i> Download Presentation</a>
        <a v-if="this.result.archive_link && this.result.tags.some((tag) => {return tag.title.toLowerCase() === 'archived';})" :href="this.result.archive_link" class="py-3 px-6 text-white inline-block bg-grass-default" target="_blank" rel="noreferrer"><i class="fas fa-archive"></i> View Webinar</a>
        <a v-if="this.result.quiz_link" :href="this.result.quiz_link" class="py-3 px-6 text-white inline-block bg-grass-default" target="_blank" rel="noreferrer"><i class="fas fa-download"></i> Take Quiz</a>

      </div>
  </details>
</template>

<script>
export default {
  name: "ViewWebinarResultDropdown",
  props: {
    result: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    collectionName: {
      type: String,
      default: null
    }
  },
  computed: {
    title() {
      return this.result.title;
    },
    fileUrl(){
      if(!this.result.file){
        return null;
      }
      if(!this.result.file[0]){
        return null;
      }
      return this.result.file[0].url;
    }
  }
}
</script>

<style scoped>

</style>